import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './Header.css';

const Header = () => {
    const [language, setLanguage] = useState('th');

    const navItems = [
        {
            name: 'หน้าแรก',
            name_en: 'Home',
            name_cn: '主页',
            url: '/',
            target: '_self'
        },
        {
            name: 'เมนู',
            name_en: 'Menu',
            name_cn: '菜单',
            url: '/menu',
            target: '_self'
        },
        {
            name: 'ที่ตั้ง',
            name_en: 'Location',
            name_cn: '地点',
            url: 'https://maps.app.goo.gl/wmgsZ6HTwukTDtc7A',
            target: '_blank'
        },
        {
            name: 'TikTok',
            name_en: 'TikTok',
            name_cn: 'TikTok',
            url: '#',
            target: '_blank'
        }
    ];

    const changeLanguage = (lang) => {
        setLanguage(lang);
        localStorage.setItem('lang', lang);
        window.location.reload();
    };

    useEffect(() => {
        const lang = localStorage.getItem('lang');
        if (lang) {
            setLanguage(lang);
        } else {
            localStorage.setItem('lang', 'th');
        }
    }, []);

    const getNavItemName = (navItem) => {
        if (language === 'en') return navItem.name_en;
        if (language === 'cn') return navItem.name_cn;
        return navItem.name;
    };

    return (
        <main>
            <div className='container mt-3'>
                <div className='row'>
                    <div className="col">
                        <nav className="navbar navbar-expand-lg navbar-light">
                            <div className="container-fluid">
                                <button className="navbar-toggler btn-sm" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav_m" aria-controls="navbarNav_m" aria-expanded="false" aria-label="Toggle navigation">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                <div className="mt-3 collapse navbar-collapse justify-content-center" id="navbarNav_m">
                                    <ul className="navbar-nav d-lg-none">
                                        {navItems.map((navItem, index) => (
                                            <li key={index} className="nav-item">
                                                <a className={`nav-link ${window.location.pathname === navItem.url ? 'active' : ''}`} href={navItem.url} target={navItem.target}>
                                                    {getNavItemName(navItem)}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                    <div className="col text-end">
                        <div className="dropdown">
                            <button className="mt-2 btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                {language === 'th' ? 'ภาษาไทย' : language === 'en' ? 'English' : '中文'}
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><button className="dropdown-item" onClick={() => changeLanguage('th')}>ภาษาไทย</button></li>
                                <li><button className="dropdown-item" onClick={() => changeLanguage('en')}>English</button></li>
                                <li><button className="dropdown-item" onClick={() => changeLanguage('cn')}>中文</button></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='row d-lg-none'>
                    <div className="col">
                        <hr />
                    </div>
                </div>
            </div>
            <div className='container mt-5'>
                <div className='row'>
                    <div className="col">
                        <h1 className='logo text-center'><a href="/">โกวเจี๊ยบ</a></h1>
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className="col">
                        <nav className="navbar navbar-expand-lg navbar-light">
                            <div className="container-fluid">
                                <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
                                    <ul className="navbar-nav">
                                        {navItems.map((navItem, index) => (
                                            <li key={index} className="nav-item">
                                                <a className={`nav-link ${window.location.pathname === navItem.url ? 'active' : ''}`} href={navItem.url} target={navItem.target}>
                                                    {getNavItemName(navItem)}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Header;
